var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKritiqueLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.82 412.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7705bc;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.73,383.69l-47.92-57.87a197,197,0,0,0,46.95-127.94C395.76,88.59,307.16,0,197.88,0S0,88.59,0,197.88,88.59,395.76,197.88,395.76a197.13,197.13,0,0,0,82.48-18c31,29.73,73.46,35.27,103,34.83A17.67,17.67,0,0,0,396.73,383.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.38 222.59 296.26 132.28 235.22 132.28 171.21 208.76 171.21 51.89 123.07 51.89 123.07 326.31 171.21 326.31 171.21 238.18 246.14 326.31 304.2 326.31 304.2 321.35 216.38 222.59"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKritiqueLogoSmall);
export default __webpack_public_path__ + "static/media/kritique-logo-small.91ca30da0ffedb0cad5f1561e3c50e1f.svg";
export { ForwardRef as ReactComponent };